<template>
	<div class="c-fields">
		<h4>Metadata</h4>
		<p class="p-small">
			The more metadata you add, the more descriptive your citations become
		</p>
		<div class="c-rows">
			<div class="c-rows__item" v-for="field in defaultFields" :key="field.key">
				<span>{{ field.name }}</span>
				<input
					class="form-control form-control-sm"
					type="text"
					@change="onChange($event, field)"
				/>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data: function () {
		return {
			defaultFields: [
				{
					name: 'Year published',
					key: '_year-published',
					type: 'date-year',
				},
				{
					name: 'Publisher',
					key: '_publisher',
					type: 'text',
				},
			],
		};
	},
	props: ['note'],
	methods: {
		onChange: function (e, field) {
			console.log(e);
			console.log(field);
		},
	},
};
</script>
<style lang="scss">
.c-fields {
	.c-rows {
		&__item {
			flex-wrap: wrap;

			input {
				margin-top: var(--margin);
			}
		}
	}
}
</style>